<div style="width: 100%; box-sizing: border-box;" class="flex-column center">
    <img [alt]="'General.WebsiteTitle' | translate"  style="max-width: 100%;" src="assets/img/404-2.png">
    <h1 style="margin-top: 20px; text-align: center; color: white;">{{'General.PageNotFound.Title' | translate}}</h1>
    <h4 style="margin-top: 0; text-align: center; color: white;">{{'General.PageNotFound.Message' | translate}}</h4>
</div>